var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-stats",staticStyle:{"height":"100%","max-width":"100%"}},[_c('div',{staticClass:"card-title",staticStyle:{"border":"none"}},[_c('i18n',{attrs:{"path":"stats.address_count"}})],1),_vm._v(" "),_c('line-chart',{attrs:{"hide-legend":"","labels":_vm.parsedChartLabels,"datasets":_vm.parsedChartDatasets}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }